//Header.jsx

import React from "react";
import Navbar from "./Navbar";
import "../styles/Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="logo-section">
          <a href="/">
            <img src="/assets/logoTitle-rondago.png" alt="RondaGO Logo" className="logo" />
          </a>
          <span className="slogan">Sua Ronda Garantida</span>
        </div>
        {/* Navbar importado */}
        <Navbar />
      </div>
    </header>
  );
};

export default Header;
